import React from 'react';
import { useI18n } from '../i18n';
import { contactTranslations } from '../lib/i18n/contact';
import ContactForm from '../components/ContactForm';
import LanguageToggle from '../components/LanguageToggle';
import { MessageCircle, Clock, Shield, Trash2 } from 'lucide-react';

export default function Contact() {
  const { lang } = useI18n();
  const t = contactTranslations[lang] || contactTranslations.en;

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="px-4 py-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <a href="/">
            <img 
              src="/Vitalo_no_Background-removebg-preview.png" 
              alt="Vitalo" 
              className="h-12 md:h-16 w-auto"
            />
          </a>
          <LanguageToggle />
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 py-8 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-semibold text-slate-900 mb-4">
            {t.title}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Form */}
          <div>
            <ContactForm />
          </div>

          {/* FAQ Section */}
          <div className="space-y-8">
            <div>
              <h2 className="text-2xl font-semibold text-slate-900 mb-6">
                {t.faq.title}
              </h2>
              <div className="space-y-6">
                {t.faq.items.map((item, index) => (
                  <div key={index} className="bg-gray-50 rounded-xl p-6">
                    <div className="flex items-start space-x-4">
                      <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        {index === 0 && <Clock className="w-4 h-4 text-teal-500" />}
                        {index === 1 && <Shield className="w-4 h-4 text-teal-500" />}
                        {index === 2 && <Trash2 className="w-4 h-4 text-teal-500" />}
                      </div>
                      <div>
                        <h3 className="font-semibold text-slate-900 mb-2">
                          {item.question}
                        </h3>
                        <p className="text-gray-600 leading-relaxed">
                          {item.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-4 py-12 border-t border-gray-200 mt-16">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-6">
            <a
              href={lang === 'ar' ? '/ar/privacy-policy' : '/privacy-policy'}
              className="text-gray-600 hover:text-teal-500 transition-colors duration-200"
            >
              {lang === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy'}
            </a>
            <span className="hidden sm:block text-gray-300">|</span>
            <a
              href={lang === 'ar' ? '/ar/terms' : '/terms'}
              className="text-gray-600 hover:text-teal-500 transition-colors duration-200"
            >
              {lang === 'ar' ? 'شروط الخدمة' : 'Terms of Service'}
            </a>
            <span className="hidden sm:block text-gray-300">|</span>
            <a
              href={lang === 'ar' ? '/ar/contact' : '/contact'}
              className="text-gray-600 hover:text-teal-500 transition-colors duration-200"
            >
              {lang === 'ar' ? 'اتصل بنا' : 'Contact'}
            </a>
          </div>
          <p className="text-sm text-gray-500">
            {lang === 'ar' ? '© 2025 فيتالو. جميع الحقوق محفوظة.' : '© 2025 Vitalo. All rights reserved.'}
          </p>
        </div>
      </footer>
    </div>
  );
}